import { notification } from 'antd';
import {LocalStorageService} from "./LocalStorageService";


 // export const apiEndpoint = `http://localhost:7023`;
 export const apiEndpoint = `https://dev.rasreview.com:11443`;

function showLoader()
{
    document.getElementById('request-spinner')?.style?.setProperty('display', 'block');
}

function hideLoaderItem()
{
    document.getElementById('request-spinner')?.style?.setProperty('display', 'none');
}

function setLogout(func)
{
    document.logout = func;
}

function getAuthorization()
{
    const token = LocalStorageService.getToken();
    return `Bearer ${token}`;
}

async function request({endpoint, method, body, onValidationError, contentType, isResponseFile, showSuccess, hideLoader, browserDownload, hideError})
{
    if(!hideLoader && !browserDownload)
        showLoader()

    try
    {
        const token = LocalStorageService.getToken();

        let headers = {};

        if(browserDownload) {
            const url = `${apiEndpoint}${endpoint}?access_token=${token}`
            const href = document.createElement('a');
            href.setAttribute('href', url)
            href.setAttribute('download', '')
            href.style.display = 'none'
            href.click();
            // window.open(url, '_blank')
            return
        }

        if(contentType)
        {
            headers['Content-Type'] = contentType;
        }

        if (token)
        {
            headers.Authorization = `Bearer ${token}`;
        }

        const response = await fetch(`${apiEndpoint}${endpoint}`, {
            method: method,
            headers: headers,
            body: JSON.stringify(body),
        });

        if (response.status === 401)
        {
            if(document.logout)
            {
                hideLoaderItem()
                document.logout()
            }
            return {
                success: false,
            }
        }

        let json = {};
        if(isResponseFile && response.status === 200)
        {
            const content = response.headers.get('Content-Disposition');
            if(content)
            {
                const fileName = content.split(';')[1].split('=')[1].replaceAll('"','');
                json = {
                    fileName,
                    success: true,
                    data: URL.createObjectURL(await response.blob())
                }
            }
            else
            {
                json = {
                    success: true,
                    data: URL.createObjectURL(await response.blob())
                }
            }
        }
        else
        {
            json = await response.json();
        }

        hideLoaderItem()

        if (response.status === 200)
        {
            if((method === 'POST' || method === 'PUT') && showSuccess)
            {
                notification.success({
                    message: 'Success',
                    placement: 'bottomRight'
                });
            }

            return {
                success: true,
                ...json
            }
        } else if (response.status === 204)
        {
            json.message && notification.success({
                message: json.message,
                placement: 'bottomRight'
            });

            return {
                success: true,
                message: json.message,
                placement: 'bottomRight'
            }
        }
        else if (response.status >= 500)
        {
            if(!hideError)
                json.Message && notification.error({
                    message: json.Message,
                    placement: 'bottomRight'
                });

            return {
                success: false,
                message: json.Message,
                errorData: json.ErrorData,
            }
        }
    }
    catch (exp)
    {
        hideLoaderItem()

        if(!hideError)
            notification.error({
                message: 'Error',
                placement: 'bottomRight'
            })

        return {
            success: false,
            data: null,
            message: null
        }
    }
}

function jsonRequest({endpoint, body, method, onValidationError, isResponseFile, showSuccess, hideLoader, browserDownload, hideError})
{
    return request({
        endpoint,
        body,
        method,
        onValidationError,
        isResponseFile,
        contentType: 'application/json',
        showSuccess,
        hideLoader,
        browserDownload,
        hideError
    })
}

function formRequest({endpoint, form, onValidationError})
{
    return new Promise((res, rej) => {
        const request = new XMLHttpRequest();
        request.open("POST", `${apiEndpoint}${endpoint}`, true);

        request.setRequestHeader('Authorization', 'Bearer '+LocalStorageService.getAuth().token)
        request.onreadystatechange = () => {
            if (request.readyState === 4 && request.status === 200) {
                res(JSON.parse(request.responseText))
            }
        };
        request.send(form);
    })
}

const Auth = {
    Login: async function(data) {
        return jsonRequest({
            endpoint: '/api/auth',
            method: 'POST',
            body: data
        })
    },
    Register: async function(data) {
        return jsonRequest({
            endpoint: '/api/register',
            method: 'POST',
            body: data
        })
    },
    Verification: async function(key) {
        return jsonRequest({
            endpoint: `/api/verification/${key}`,
            method: 'GET',
        })
    },
    SendResetPasswordMail: async function(data) {
        return jsonRequest({
            endpoint: '/api/reset/password/send',
            method: 'POST',
            body: data
        })
    },
    PasswordResetLinkActive: async function(key) {
        return jsonRequest({
            endpoint: `/api/reset/password/${key}/active`,
            method: 'POST',
        })
    },
    ResetPassword: async function(key, data) {
        return jsonRequest({
            endpoint: `/api/reset/password/${key}`,
            method: 'POST',
            body: data
        })
    },
}

const User = {
    Information: async function()
    {
        return jsonRequest({
            endpoint: `/api/User/Information`,
            method: 'GET'
        })
    },
    ChangePassword: async function(input)
    {
        return jsonRequest({
            endpoint: `/api/User/ChangePassword`,
            method: 'POST',
            body: input,
            showSuccess: true
        })
    },
    EditUser: async function(input)
    {
        return jsonRequest({
            endpoint: `/api/User/EditUser`,
            method: 'POST',
            body: input,
            showSuccess: true
        })
    },
    UserSettings: async function()
    {
        return jsonRequest({
            endpoint: `/api/User/UserSettings`,
            method: 'GET',
        })
    },
    UpdateUserSettings: async function(input)
    {
        return jsonRequest({
            endpoint: `/api/User/UpdateUserSettings`,
            method: 'POST',
            body: input,
            showSuccess: true
        })
    },
    UpdateUserDontShow: async function(input)
    {
        return jsonRequest({
            endpoint: `/api/User/UpdateUserDontShow`,
            method: 'POST',
            body: input,
            showSuccess: false
        })
    },
}

const RasCheck = {
    UpdateMessageInfo: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/UpdateMessageInfo`,
            method: 'POST',
            body: data,
            showSuccess: true
        })
    },
    SaveHelpContent: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/SaveHelpContent`,
            method: 'POST',
            body: data,
            showSuccess: true
        })
    },
    GetHelpContent: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/GetHelpContent`,
            method: 'GET',
        })
    },
    GetMessageInfo: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/GetMessageInfo`,
            method: 'POST',
            body: data
        })
    },
    GetVersion: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/GetVersion`,
            method: 'GET'
        })
    },
    ParseInternal: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/ParseInternal`,
            method: 'POST',
            body: data
        })
    },
    ParseCompare: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/ParseCompare`,
            method: 'POST',
            body: data
        })
    },
    RunComplete: async function(key) {
        return jsonRequest({
            endpoint: `/api/RasReview/RunComplete/${key}`,
            method: 'POST'
        })
    },
    InternalCheck: async function({target, key, projectHash}) {
        return jsonRequest({
            endpoint: `/api/RasReview/InternalCheck`,
            method: 'POST',
            body: {target, key, baseHash: projectHash}
        })
    },
    CompareCheck: async function({target, key, baseHash, compareHash}) {
        return jsonRequest({
            endpoint: `/api/RasReview/CompareCheck`,
            method: 'POST',
            body: {target, key, baseHash, compareHash}
        })
    },
    GetCSList: async ({geometryFile}) => {
        return jsonRequest({
            endpoint: `/api/RasReview/GetCSList`,
            method: 'POST',
            body: {
                geometryFile
            }
        })
    },
    HelperText: async function() {
        return jsonRequest({
            endpoint: '/api/RasReview/HelperText',
            method: 'GET',
        })
    },
    ShpToGeoJson: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/ShpToGeoJson`,
            method: 'POST',
            body: data
        })
    },
    ShpToKMZ: async function(data) {
        return jsonRequest({
            endpoint: `/api/RasReview/ShpToKmz`,
            method: 'POST',
            body: data
        })
    },
}

const UserProject = {
    SaveProject: async function(data) {
        return jsonRequest({
            endpoint: `/api/UserProject/SaveProject`,
            method: 'POST',
            body: data,
            showSuccess: false
        })
    },
    DeleteProject: async function(key) {
        return jsonRequest({
            endpoint: `/api/UserProject/DeleteProject/${key}`,
            method: 'DELETE',
            showSuccess: true
        })
    },
    GetProjectState: async function(key) {
        return jsonRequest({
            endpoint: `/api/UserProject/GetProjectState/${key}`,
            method: 'GET',
            showSuccess: true
        })
    },
    UploadProject: async function(data) {
        return jsonRequest({
            endpoint: `/api/UserProject/UploadProject`,
            method: 'POST',
            body: data
        })
    },
    UserStatistics: async function() {
        return jsonRequest({
            endpoint: `/api/UserProject/UserStatistics`,
            method: 'GET'
        })
    },
    GetProjectsGrid: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/UserProject/GetProjectsGrid`,
            method: 'POST',
            body: gridInput
        })
    },
    CheckHistory: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/UserProject/CheckHistory`,
            method: 'POST',
            body: gridInput
        })
    },
    CompareHistory: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/UserProject/CompareHistory`,
            method: 'POST',
            body: gridInput
        })
    },
}

const AdminDashboard = {
    GetAppSettings: async function() {
        return jsonRequest({
            endpoint: `/api/Admin/GetAppSettings`,
            method: 'GET',
            hideLoader: true
        })
    },
    SetSignUpEnabled: async function(enabled) {
        return jsonRequest({
            endpoint: `/api/Admin/SetSignUpEnabled`,
            method: 'POST',
            body: {enabled}
        })
    },
    GetUserList: async function() {
        return jsonRequest({
            endpoint: `/api/Admin/GetUserList`,
            method: 'GET',
        })
    },
    GetUserDataGrid: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/Admin/GetUserDataGrid`,
            method: 'POST',
            body: gridInput
        })
    },
    GetUserStatistics: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/Admin/GetUserStatistics`,
            method: 'POST',
            body: gridInput
        })
    },
    GetProjectsDataGrid: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/Admin/GetProjectsDataGrid`,
            method: 'POST',
            body: gridInput
        })
    },
    GetCheckHistoryGrid: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/Admin/GetCheckHistoryGrid`,
            method: 'POST',
            body: gridInput
        })
    },
    GetCompareHistoryGrid: async function(gridInput) {
        return jsonRequest({
            endpoint: `/api/Admin/GetCompareHistoryGrid`,
            method: 'POST',
            body: gridInput
        })
    },
}

const Report = {
    DownloadWord: async function(htmlData) {
        return jsonRequest({
            endpoint: `/api/Report/DownloadWord`,
            method: 'POST',
            body: htmlData
        })
    },
    DownloadPDF: async function(htmlData) {
        return jsonRequest({
            endpoint: `/api/Report/DownloadPDF`,
            method: 'POST',
            body: htmlData
        })
    },
}

const AppSettings = {
    GetSettings: async function() {
        return jsonRequest({
            endpoint: `/api/AppSettings/GetSettings`,
            method: 'GET',
            hideLoader: true,
            hideError: true
        })
    },
}

const ApiService = {
    setLogout,
    getAuthorization,
    User,
    Auth,
    RasCheck,
    UserProject,
    AdminDashboard,
    AppSettings,
    Report
}

export default ApiService;
